<app-page-frame frameTitle="Profile" titleIcon="bi bi-person-lines-fill" homeRoute="/dashboard">
    <app-profile-component></app-profile-component>
</app-page-frame>